// This module uses to hide https://rollbar.com/Reedsy/Reedsy-Discovery/items/1226/ issues
export default function ignoreTimeout(error) {
  const timeoutMessage = '"Timeout"';
  if (typeof error === 'string' && error === timeoutMessage) return true;
  if (error instanceof Error && error.message.toString() === timeoutMessage) return true;

  return false;
}
